<template>
  <div id="app">
    <!-- WILL BE DELETED IF DIRECTBOOKING.ID IS RELEASED -->
    <warning-box
      v-if="$route.name == 'GeneralHomepage' && !general_page"
      title="Something wrong"
      body="Merchant not found">
    </warning-box>
    <template v-else>
      <notifications />
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import company_logo from '@/assets/guestaps.png';
import { mapMutations, mapGetters } from 'vuex';
import WarningBox from '@/components/general/WarningBox';

export default {
  components: {
    WarningBox,
  },
  computed: {
    ...mapGetters(['getCompanyType']),
    first_matched_route() {
      return this.$route.matched.length > 0 ? this.$route.matched[0].name : '';
    },
    general_page() {
      return (
        this.$app_env == 'dev' &&
        this.first_matched_route == 'GeneralHomepageBase'
      );
    },
  },
  mounted() {
    if (this.$route.name != 'DevelopmentOnly') {
      this.loadFirstData();
    }
  },
  methods: {
    ...mapMutations([
      'setCompanyType',
      'resetAllDataHotel',
      'resetAllDataMarketing',
      'resetAllDataRestaurant',
      'resetAllDataTicket',
      'resetAllDataGeneral',
    ]),
    loadFirstData() {
      let company_type_params = this.general_page ? 'GENERAL' : 'MERCHANT';
      let page_module_type = this.$route.meta.module_type;
      if (this.first_matched_route == 'MerchantPageBase') {
        company_type_params = 'MERCHANT';
      } else {
        this.resetAllDataVuex();
        if (page_module_type == 'general-affiliate') {
          if (this.getCompanyType == 'MERCHANT') this.$logout();
          company_type_params = 'AFFILIATE';
        }
        if (page_module_type == 'community') company_type_params = 'COMMUNITY';
      }
      this.setCompanyType(company_type_params);
    },
    resetAllDataVuex() {
      this.resetAllDataHotel();
      this.resetAllDataMarketing();
      this.resetAllDataRestaurant();
      this.resetAllDataTicket();
      this.resetAllDataGeneral();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue